import { createLucideIcon } from "lucide-react";

/**
 * Custom loan icon (document + coin), inspired by common loan illustrations:
 * folded agreement sheet with title/lines, and a coin in front.
 */
export const LoanIcon = createLucideIcon("LoanIcon", [
  // Folded loan document
  ["path", { d: "M6 3h8l4 4v13a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" }],
  ["path", { d: "M14 3v4h4" }],
  // Title + body lines (loan agreement text)
  ["path", { d: "M8 10h6" }],
  ["path", { d: "M8 13h5.5" }],
  ["path", { d: "M8 16h4" }],
  // Coin in foreground (hand-held money)
  ["circle", { cx: "17.5", cy: "17.5", r: "4.5" }],
  ["path", { d: "M17.5 15.4v4.2" }],
  ["path", { d: "M16.2 16.3c.4-.55 1-.85 1.6-.85.95 0 1.55.5 1.55 1.15 0 .6-.5 1-1.4 1.1h-.75c-.9.1-1.4.5-1.4 1.15 0 .7.65 1.2 1.65 1.2.6 0 1.2-.3 1.55-.85" }],
]);
